/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

////* Open external links in a new tab *////

document.querySelectorAll('a')?.forEach(link => {
  if (link.hostname != window.location.hostname) {
    link.target = '_blank';
    link.rel = 'noreferrer noopener';
  }
})

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  class FreeGiftModal extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector('.custom-modal-close');
      this.freeGiftSelect = this.querySelector('#free-gift__select');
      this.freeGiftAtc = this.querySelector('.free-gift__atc');
      this.galleryImages = this.querySelectorAll('.free-gift__images img');
    }

    connectedCallback() {
      this.initializeTabs();
    }
    
    initializeTabs() {
      let openButton = document.querySelectorAll('.free-gift__trigger');
      if (openButton.length > 0) {
        openButton.forEach(el => el.addEventListener('click', this.open));
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hide());
      }
      if (this.freeGiftSelect) {
        this.freeGiftSelect.addEventListener('change', (e) => this.changeSelectVariantId(e));
      }
      if (this.freeGiftAtc) {
        this.freeGiftAtc.addEventListener('click', () => this.addFreeGiftToCart());
      }
      if (this.galleryImages.length > 0) {
        this.galleryImages.forEach(el => el.addEventListener('click', (e) => this.changeMainImage(e)));
      }
    }
  
    open() {
      this.classList.add('active');
      document.querySelectorAll('.shopify-section-group-group-header').forEach(el => el.style.display = 'none');
    }
  
    hide() {
      this.classList.remove('active');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.shopify-section-group-group-header').forEach(el => el.style.display = 'block');
    }

    changeMainImage = (e) => {
      let desktopGalleryMainImage = this.querySelector('.free-gift__main-img img');
      let clickedImg = e.target.closest('img');
      let newSrc = clickedImg.src;
      let oldSrc = desktopGalleryMainImage.src;

      desktopGalleryMainImage.src = newSrc;
      clickedImg.src = oldSrc;
    };
  
    changeSelectVariantId() {
      let varId = this.freeGiftSelect.value;
      this.freeGiftAtc.dataset.variantId = varId;
    }
  
    async addFreeGiftToCart() {
      let formData = {
        items: [
          {
            id: this.freeGiftAtc.dataset.variantId,
            quantity: 1,
            properties: {
              "_is_free_gift": true,
              "_parent_product_handle": this.freeGiftAtc.dataset.parentProduct
            }
          },
        ],
      };
  
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:popdown', { bubbles: true, detail: { variant: response } })
          );
          document.dispatchEvent(new CustomEvent('theme:cart:changed', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
          document.querySelector('#drawer-cart').classList.remove('display-none');
          document.querySelector('#drawer-cart').classList.add('drawer--visible');
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(() => {
          this.classList.remove('active');
          document.querySelectorAll('.shopify-section-group-group-header').forEach(el => el.style.display = 'block');
        });
    }
  
    
  }
  
  customElements.define('free-gift-modal', FreeGiftModal);


//Newsletter subscription popup (cyclist or runners)
// Klaviyo popup functionality
//Newsletter subscription popup (footer form)
document.addEventListener('DOMContentLoaded', function() {
  // Get the footer newsletter form specifically
  const footerNewsletterForm = document.querySelector('form[data-newsletter-form][id="footer-newsletter"]');
  const popup = document.getElementById('klaviyo-popup');
  const closeButton = document.getElementById('klaviyo-popup-close');
  
  // Store the user's email when they submit the form
  let footerEmail = '';
  
  if (footerNewsletterForm) {
    footerNewsletterForm.addEventListener('submit', function(event) {
      // Store the email value
      const emailInput = this.querySelector('input[name="contact[email]"]');
      if (emailInput) {
        footerEmail = emailInput.value;
        console.log("Captured email from footer form:", footerEmail);
        
        // Store email in sessionStorage with specific key
        sessionStorage.setItem('footerNewsletterEmail', footerEmail);
      }
    });
  }
  
  // Function to show the popup with footer email
  function showKlaviyoPopupForFooter() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Prevent body scrolling
    
    // Try to get email from sessionStorage if not set directly
    if (!footerEmail) {
      footerEmail = sessionStorage.getItem('footerNewsletterEmail');
      console.log("Retrieved footer email from session storage:", footerEmail);
    }
    
    // Set the email with a delay to ensure Klaviyo form is loaded
    setTimeout(function() {
      const klaviyoEmailField = document.querySelector('#klaviyo-popup-content input[type="email"]');
      if (klaviyoEmailField && footerEmail) {
        klaviyoEmailField.value = footerEmail;
        console.log("Set Klaviyo email field to footer email:", footerEmail);
        
        // Force an input event to ensure Klaviyo recognizes the change
        const event = new Event('input', { bubbles: true });
        klaviyoEmailField.dispatchEvent(event);
      } else {
        console.log("Could not set footer email. Field found:", !!klaviyoEmailField, "Email value:", footerEmail);
      }
    }, 800); // Increased timing slightly
  }
  
  // Close popup event handlers
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      popup.style.display = 'none';
      document.body.style.overflow = ''; // Restore body scrolling
    });
  }
  
  if (popup) {
    popup.addEventListener('click', function(event) {
      if (event.target === popup) {
        popup.style.display = 'none';
        document.body.style.overflow = ''; // Restore body scrolling
      }
    });
  }
  
  // Check specifically for footer form submission
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get('customer_posted');
  
  if (customerPosted === 'true' && window.location.hash === '#footer-newsletter') {
    console.log("Footer form was submitted");
    
    const errorMessage = document.querySelector('.newsletter__message--error');
    
    if (!errorMessage || !errorMessage.offsetParent) {
      console.log("No error message for footer form, showing popup");
      setTimeout(showKlaviyoPopupForFooter, 500);
    }
  }
});

//Product page newsletter popup handler
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a page with the product newsletter popup - use more specific selector
  const productNewsletterForm = document.querySelector('form[id^="newsletter-modal-form-newsletter_signup"]');
  
  if (!productNewsletterForm) return; // Exit if we're not on a page with this form
  
  // Store the user's email when they submit the form
  let productPopupEmail = '';
  
  productNewsletterForm.addEventListener('submit', function(event) {
    // Store the email value
    const emailInput = this.querySelector('input[name="contact[email]"]');
    if (emailInput) {
      productPopupEmail = emailInput.value;
      console.log("Captured email from product popup:", productPopupEmail);
      
      // Store email in sessionStorage with a clear key name
      sessionStorage.setItem('productNewsletterEmail', productPopupEmail);
    }
  });
  
  // Check specifically for product form submission by checking the hash
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get('customer_posted');
  const urlHash = window.location.hash;
  
  if (customerPosted === 'true' && urlHash.includes('newsletter-modal-form-newsletter_signup')) {
    console.log("Product newsletter form was submitted");
    
    // Success/error message checking
    const successMessage = document.querySelector('.newsletter__message--success');
    const errorMessage = document.querySelector('.newsletter__message--error');
    
    if ((successMessage && successMessage.offsetParent) || 
        (!errorMessage || !errorMessage.offsetParent)) {
      console.log("Showing Klaviyo popup after product newsletter submission");
      
      // Try to get email from sessionStorage if not directly set
      if (!productPopupEmail) {
        productPopupEmail = sessionStorage.getItem('productNewsletterEmail');
        console.log("Retrieved product email from storage:", productPopupEmail);
      }
      
      // Show the Klaviyo popup with the product email
      setTimeout(function() {
        const klaviyoPopup = document.getElementById('klaviyo-popup');
        if (klaviyoPopup) {
          klaviyoPopup.style.display = 'flex';
          document.body.style.overflow = 'hidden';
          
          setTimeout(function() {
            const klaviyoEmailField = document.querySelector('#klaviyo-popup-content input[type="email"]');
            if (klaviyoEmailField && productPopupEmail) {
              klaviyoEmailField.value = productPopupEmail;
              console.log("Set Klaviyo email field to product email:", productPopupEmail);
              
              const event = new Event('input', { bubbles: true });
              klaviyoEmailField.dispatchEvent(event);
            } else {
              console.log("Could not set product email. Field found:", !!klaviyoEmailField, "Email value:", productPopupEmail);
            }
          }, 800); // Increased timing 
        }
      }, 500);
    }
  }
});
//Newsletter subscription after subscribtion popup on product page


